export default {
    createImg(file, item, callback) {
        let that = this;
        let windowURL = window.URL;
        let videoUrl = windowURL.createObjectURL(file.raw);
        let videoDom = document.createElement('video');
        videoDom.setAttribute('src', videoUrl);
        videoDom.setAttribute('muted', 'true');
        videoDom.setAttribute('controls', 'controls');
        videoDom.setAttribute('style', 'position:absolute;visibility:hidden;z-index:-100;');
        document.getElementsByTagName('body')[0].appendChild(videoDom);
        videoDom.addEventListener('canplay', () => {
            videoDom.volume = 0;
            videoDom.play();
            setTimeout(() => {
                videoDom.pause();
                var scale = 0.25,
                    canvas = document.createElement("canvas"),
                    canvasFill = canvas.getContext('2d');
                canvas.width = videoDom.videoWidth * scale;
                canvas.height = videoDom.videoHeight * scale;
                canvasFill.drawImage(videoDom, 0, 0, canvas.width, canvas.height);
                let url = canvas.toDataURL("image/jpeg");
                callback && callback(item, that.dataURLtoFile(url));
                document.getElementsByTagName('body')[0].removeChild(videoDom);
            }, 500);
        });
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], new Date().getTime(), { type: mime });
    }
}


// WEBPACK FOOTER //
// ./src/utils/createImgByVideo.js